import { createFileRoute } from '@tanstack/react-router';
import { FollowupsPage } from '@/features/scheduling/pages/followups-page';

const TABS = ['today', 'overdue', 'upcoming', 'all'] as const;

/** Tab, window, search and "mine" live in the URL so a filtered list can be shared and survives a refresh. */
export const Route = createFileRoute('/_app/followups')({
  validateSearch: (
    s: Record<string, unknown>,
  ): { tab?: (typeof TABS)[number]; window?: number; q?: string; mine?: boolean } => ({
    tab: TABS.find((t) => t === s.tab),
    window: [7, 14, 30].find((w) => w === Number(s.window)),
    q: typeof s.q === 'string' && s.q ? s.q : undefined,
    mine: s.mine === true || s.mine === 'true' ? true : undefined,
  }),
  component: FollowupsPage,
});
